






































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Getter } from 'vuex-class'
import { Prop } from 'vue-property-decorator'

// import DigitalCurrency5AccountThumbnail from '../../digital-currency-account/account-thumbnail/index.vue'
// import DigitalCurrency7ccountBalanceNumberWithIcon from '../../digital-currency-account/account-balance-number-with-icon/index.vue'
// import Input1TextInputForSearch from '../../../../website/data-structures/text-input-for-search/index.vue'

import QRCode from 'qrcode'

const namespace = 'digitalCurrency'

@Component({
  components: {
    // DigitalCurrency5AccountThumbnail,
    // DigitalCurrency7ccountBalanceNumberWithIcon,
    // Input1TextInputForSearch
  }
})
class DigitalCurrency10AccountShortIntroduction extends Vue {

  @Prop({ default: '' }) accountId?: string

  @Getter('getDigitalCurrencyAccount', { namespace }) getDigitalCurrencyAccount?: any

  accountQRCodeDataUrl: string = ''

  isCopiedTextList: boolean[] = [false, false]

  get digitalCurrencyAccount () {
    return this.getDigitalCurrencyAccount(this.accountId)
  }

  async mounted () {
    this.accountQRCodeDataUrl = await QRCode.toDataURL(this.digitalCurrencyAccount.accountId || 'default')
  }

  copyText (textValue: string, textIndex: number) {
    navigator.clipboard.writeText(textValue).catch((_errorMessage: any) => { /* */ })

    if (!textIndex && textIndex !== 0) {
      return
    }

    Vue.set(this.isCopiedTextList, textIndex, true)

    setTimeout(() => {
      Vue.set(this.isCopiedTextList, textIndex, false)
    }, 1000)
  }

  // Emit Toggle show content
  emitToggleShowContent ({ isVisible }: { isVisible: boolean }) {
    this.$emit('toggleShowContent', { isVisible })
  }
}

export default DigitalCurrency10AccountShortIntroduction


